import { AxiosResponse } from 'axios';
import { axiosInstance } from '@fides/fides-react-components';
import { endpoints } from 'core/consts';
import { TransactionsPage, TransactionsQuery } from './Transactions';

export const getTransactionsByGroup = (
  transactionGroupUniqueId: string,
  query: TransactionsQuery
): Promise<AxiosResponse<TransactionsPage>> => {
  const url = `${endpoints.EFTApiUrl}/${endpoints.transactionGroup}/${transactionGroupUniqueId}`;
  return axiosInstance.get(url, {
    baseURL: undefined,
    params: query,
  });
};
